import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../app.config';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ReportConverter } from './converters/ReportConverter';

@Injectable({
  providedIn: 'root'
})
export class ManageReportService {

  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {
  }

  public remove(project_id, ticket_id): Observable<any> {
    const params = new HttpParams()
      .set('project_id', project_id.toString())
      .set('ticket_id', ticket_id.toString());
    return this
      .http
      .delete(
        this.config.getEndpoint('ticket/remove'),
        { params });
  }


  public inbox(): Observable<any> {
    const project = JSON.parse(localStorage.getItem('project_id'));
    const body = {
      project_id: project.projectID.id,
      reporter_filters: [],
      search_sub_projects: true,
      ticket_filters: [
        {
          attribute: "closure",
          value: "NEW",
          comparator: "EQUALS"
        }
      ]
    };
    return this
      .http
      .post(
        this.config.getEndpoint('ticket/search'),
        body,
        {})
      .pipe(
        map((response: Array<any>) => response.map(ReportConverter.toUiMReport))
      );
  }

  public reject(projectId: number, ticketId: number, reason: string, language: string): Observable<any> {
    let params = new HttpParams()
      .append('ticket_id', ticketId.toString())
      .append('project_id', projectId.toString());
    if (language) {
      params = params.append('language', language);
    }
    return this.http.post(this.config.getEndpoint('ticket/reject'), reason, { params });
  }

  public accept(projectId: number, ticketId: number, newValues: any, language: string): Observable<any> {
    let params = new HttpParams()
      .append('ticket_id', ticketId.toString())
      .append('project_id', projectId.toString());
    if (language) {
      params = params.append('language', language);
    }
    return this.http.post(this.config.getEndpoint('ticket/accept'), newValues, { params });
  }

  public rejected(): Observable<any> {
    const project = JSON.parse(localStorage.getItem('project_id'));
    const body = {
      project_id: project.projectID.id,
      reporter_filters: [],
      search_sub_projects: true,
      ticket_filters: [
        {
          attribute: "closure",
          value: "REJECTED",
          comparator: "EQUALS"
        }
      ]
    };
    return this
      .http
      .post(
        this.config.getEndpoint('ticket/search'),
        body,
        {})
      .pipe(
        map((response: Array<any>) => response.map(ReportConverter.toUiMReport))
      );
  }

  public accepted(): Observable<any> {
    const project = JSON.parse(localStorage.getItem('project_id'));
    const body = {
      project_id: project.projectID.id,
      reporter_filters: [],
      search_sub_projects: true,
      ticket_filters: [
        {
          attribute: "closure",
          value: "ACCEPTED",
          comparator: "EQUALS"
        }
      ]
    };
    return this
      .http
      .post(
        this.config.getEndpoint('ticket/search'),
        body,
        {})
      .pipe(
        map((response: Array<any>) => response.map(ReportConverter.toUiMReport))
      );
  }

  public applyFilters(filterObj): Observable<any> {
    const project = JSON.parse(localStorage.getItem('project_id'));
    const body = {
      project_id: project.projectID.id,
      reporter_filters: [],
      search_sub_projects: true,
      ticket_filters: Object.values(filterObj).filter(f => f['value'])
    };
    return this
      .http
      .post(
        this.config.getEndpoint('ticket/search'),
        body,
        {})
      .pipe(
        map((response: Array<any>) => response.map(ReportConverter.toUiMReport))
      );
  }

  public mergeReports(data): Observable<any> {
    const id = JSON.parse(localStorage.getItem('project_id'));
    const params = new HttpParams().set('project_id', id.projectID.id.toString())
      .set('new_ticket_id', data['new_ticket_id'])
      .set('original_ticket_id', data['original_ticket_id']);

    const token = JSON.parse(localStorage.getItem('token_info'));
    //FIXME when we getting the token type is the first letter is lowercase, it's wrong coz when we revoke the token, the first letter in type must be in uppercase
    const headers: HttpHeaders = new HttpHeaders()
      .append('Authorization', `Bearer ${token['access_token']}`);

    return this
      .http
      .post(
        this.config.getEndpoint('ticket/merge'),
        data.newValues,
        { headers, params });
  }

  mergeMultiple(ids: string[], data: any) {
    const project = JSON.parse(localStorage.getItem('project_id'));

    let params = new HttpParams().set('project_id', project.projectID.id.toString());
    ids.forEach(id => params = params.append('ids', id));

    return this.http.post(this.config.getEndpoint('ticket/merge_multiple'), data, { params });
  }

}
